/* eslint-disable tss-unused-classes/unused-classes */
import { makeStyles } from 'tss-react/mui';
import { CustomFilter } from 'app/ComponentLibrary/Filter';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { trackPromise } from 'react-promise-tracker';
import { useDispatch, useSelector } from 'react-redux';
import { Collapse, Grid } from '@mui/material';
import { SearchPageIcons } from 'app/ComponentLibrary/Filter/SearchPageIcons';
import { gridStateActions } from '@AMIEWEB/Common/Grid/GridStateManagement/GridState.redux';
import { SearchType } from 'app/models/GlobalSearch/GlobalSearch';
import { selectGridState } from '@AMIEWEB/Common/Grid/GridStateManagement/GridState.selectors';
import { CandidatePlacementsFilter, defaultFilterValues } from './filterUtils';
import { getPlacementStatusTreeOptions, getSearchFilterOptions } from 'app/services/SharedServices/SharedServices';
import { useFormContext } from 'react-hook-form';
import { getMultiSelectOptions } from '@AMIEWEB/GlobalSearch/helper';
import { setFilterValues } from './ResetFilterValues';
import { ff_placement_region_fields } from 'app/constants/FeatureFlags/Placement/Keys';
import { useDecision } from '@optimizely/react-sdk';

const useStyles = makeStyles()({
  accountManagerField: {
    minWidth: 200,
  },
  placementRecruiterField: {
    minWidth: 155,
  },
  archiveOptsField: {
    minWidth: 126,
  },
  amDivisionField: {
    minWidth: 126,
  },
  affiliateField: {
    minWidth: 130,
  },
  fillterCollapse: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: '3px',
  },
  collapse: {
    paddingTop: '4px',
  },
});

export const OrderPlacementSearchFilter = props => {
  const { classes } = useStyles();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { reset, setValue } = useFormContext();
  const gridState = useSelector(selectGridState);
  const [filtersExpanded, setFiltersExpanded] = useState<boolean>(false);
  const [regionFlag] = useDecision(ff_placement_region_fields);
  const gridSpecs = useRef(
    new CandidatePlacementsFilter(
      {
        statusOpts: [],
        extensionOpts: [],
        regionOpts: [],
      },
      t,
      regionFlag.enabled,
    ),
  );

  const [fields, setFields] = useState<any>(gridSpecs.current.getOrderPlacementSearchFilterSpecs());
  const fetchPlacementFilterSpecs = async () => {
    getSearchFilterOptions('extensionStatuses', true).then(res => {
      gridSpecs.current.filterSpecs.extensionOpts = getMultiSelectOptions(res || [], { withoutAllOption: true });
      const fieldsSchema = gridSpecs.current.getOrderPlacementSearchFilterSpecs();
      setFields(fieldsSchema);
    });
    getPlacementStatusTreeOptions().then(res => {
      gridSpecs.current.filterSpecs.statusOpts = res || [];
      const fieldsSchema = gridSpecs.current.getOrderPlacementSearchFilterSpecs();
      setFields(fieldsSchema);
    });
    getSearchFilterOptions('orderplacementregions', true).then(res => {
      gridSpecs.current.filterSpecs.regionOpts = getMultiSelectOptions(res || [], { withoutAllOption: true });
      const fieldsSchema = gridSpecs.current.getOrderPlacementSearchFilterSpecs();
      setFields(fieldsSchema);
    });
  };

  const resetFilter = () => {
    setFilterValues(setValue);
    reset({ ...defaultFilterValues });
    dispatch(
      gridStateActions.setFilterAttributes({
        ...gridState.filterAttributes,
        filterObject: Object.entries(defaultFilterValues),
      }),
    );
    props.onClickHandler(defaultFilterValues, {});
  };

  const handleChange = () => {
    setFiltersExpanded(!filtersExpanded);
  };

  useEffect(() => {
    trackPromise(fetchPlacementFilterSpecs(), 'global-search-call');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Grid container spacing={2}>
      <Grid item xs={11}>
        <Collapse timeout={200} in={filtersExpanded} collapsedSize={45} className={classes.collapse}>
          <CustomFilter
            fields={fields}
            justifyContent={'flex-start'}
            version2
            resetBtn
            analytics={{
              caller: t('order.orderSearch'),
              onApply: true,
              properties: {
                category: SearchType.placement,
              },
            }}
          />
        </Collapse>
      </Grid>
      <Grid item xs={1} className={classes.fillterCollapse}>
        <SearchPageIcons
          resetlbutton
          funnelButton
          onResetForm={() => resetFilter()}
          onAdvancedFilterClick={() => {
            handleChange();
          }}
          checked={filtersExpanded}
        />
      </Grid>
    </Grid>
  );
};
